import React, { useState } from 'react';
import TabsComponent from '@shared/components/tabs/tabs';
import { entertainmentTabsData } from '@shared/utils/tabs.utils';
import { TabVariant } from '@utils/tabs.utils.ts';
import {
  WifiIcon,
  MobileIcon,
  TabletIcon,
  TVIcon
} from '@components/icons/svg-icon.tsx';

// Self-contained data-URI flags so the flag-tab example needs no remote assets.
const flagBlue =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20'><rect width='20' height='20' fill='%234c5cff'/></svg>";
const flagRed =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20'><rect width='20' height='20' fill='%23eb5757'/></svg>";

const segmentedDeviceTabs = [
  { label: 'TV', value: 'tv', icon: <TVIcon /> },
  { label: 'Tablet', value: 'tablet', icon: <TabletIcon /> },
  { label: 'Mobile', value: 'mobile', icon: <MobileIcon /> },
  { label: 'Captive', value: 'captive', icon: <WifiIcon stroke="var(--dark-2)" /> }
];

const flagTabs = [
  { label: 'English', value: 'en', flag: flagBlue },
  { label: 'Arabic', value: 'ar', flag: flagRed }
];

const disablableTabs = [
  { label: 'tab_label_devices', value: 'devices' },
  { label: 'tab_label_screens', value: 'screens' },
  { label: 'tab_label_events', value: 'events' }
];

const Block = ({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) => (
  <div className="flex flex-col gap-3">
    <p className="font-semibold text-gray-700">{title}</p>
    {children}
  </div>
);

const UiKitTabs: React.FC = () => {
  const [activeTab, setActiveTab] = useState('live-tv');
  const [segmentedTab, setSegmentedTab] = useState('tv');
  const [compactTab, setCompactTab] = useState('tv');
  const [flagTab, setFlagTab] = useState('en');
  const [disablableTab, setDisablableTab] = useState('devices');

  const change =
    (setter: (v: string) => void) =>
    (_e: React.SyntheticEvent, value: string) =>
      setter(value);

  return (
    <div className="flex flex-col gap-10">
      <h2 className="text-xl font-bold text-gray-800">Tabs</h2>

      <Block title="Default">
        <TabsComponent
          value={activeTab}
          onChange={change(setActiveTab)}
          tabs={entertainmentTabsData}
        />
      </Block>

      <Block title="Default with flags">
        <TabsComponent
          value={flagTab}
          onChange={change(setFlagTab)}
          tabs={flagTabs}
        />
      </Block>

      <Block title="Disabled tab (Events)">
        <TabsComponent
          value={disablableTab}
          onChange={change(setDisablableTab)}
          tabs={disablableTabs}
          disabled={{ events: true }}
        />
      </Block>

      <Block title="Segmented with icons">
        <TabsComponent
          variant={TabVariant.Segmented}
          value={segmentedTab}
          onChange={change(setSegmentedTab)}
          tabs={segmentedDeviceTabs}
        />
      </Block>

      <Block title="Segmented compact">
        <div className="max-w-md">
          <TabsComponent
            variant={TabVariant.Segmented}
            segmentedCompact
            value={compactTab}
            onChange={change(setCompactTab)}
            tabs={segmentedDeviceTabs}
          />
        </div>
      </Block>
    </div>
  );
};

export default UiKitTabs;
